import z from 'zod'

const EnvSchema = z.object({
	NODE_ENV: z.enum(['development', 'production', 'test', 'staging']),
	VITE_APP_VERSION: z.string(),
	VITE_APP_BUILD: z.string().optional().default('local'),
	VITE_AMPLITUDE_KEY: z.string(),
	VITE_SENTRY_DSN: z.string(),
	VITE_INTERCOM_APP_ID: z.string().optional(),
	VITE_MOCK_ENABLED: z.string().optional().default('false'),
	VITE_CROWDIN_DIST_HASH: z.string(),
})

export const env = EnvSchema.parse(import.meta.env)
